export const CARD_MARGIN = 12;

export const GET_COMMUNITY_FAVORITE_HEIGHT = (isMobile: boolean) =>
  isMobile ? 28 : 32;

export const GET_CARD_PADDING = (isMobile: boolean) => (isMobile ? 12 : 24);

export const GET_CARD_CONTENT_GAP = (isMobile: boolean) => (isMobile ? 20 : 32);

export const GET_TOP_SECTION_GAP = (isMobile: boolean) => (isMobile ? 4 : 12);

export const TAG_ROW_HEIGHT = 21.5;

export const SPEAKER_PROFILE_HEIGHT = 54;

export const SPEAKER_SEPARATOR_HEIGHT = 12;

export const GET_TOP_ROW_HEIGHT = (isMobile: boolean) => (isMobile ? 40 : 44);

export const GET_SESSION_TITLE_AND_DESCRIPTION_HEIGHT = (isMobile: boolean) =>
  isMobile ? 126 : 144;
